module.exports = __webpack_public_path__ + "media/images/themes/spring_bohemian/ring_semi_transparent2-e3eacd7d17b41d1adfe26e9d86b2fe4a.png";